__webpack_require__.p = "/ipo-initial-public-offering/_next/";